import config from 'config';

import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
import MediaFormats from 'types/MediaFormats';
//
import { QRCodeCanvas } from "qrcode.react";

import classes from './styles.module.css';
import useCompactLayout from 'hooks/useCompactLayout';

const QrCode:FC = () => {
  const isCompact = useCompactLayout();
  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;
  const isRectLogoFormat = quiz?.publicLeaderboard.quizQrCodeLogoFormat === MediaFormats.RectLogo;

  if (!quiz?.publicLeaderboard.quizQRCodeEnabled) return null;

  if (isCompact) {
    return (
      <div className="flex-1 min-w-0 min-h-0 flex flex-col items-center justify-center gap-2">
        <div className="flex-1 min-h-0 w-full flex items-center justify-center">
          <div className={`${classes.qrWrapper} aspect-square h-full max-w-full flex flex-col p-2 rounded-xl shadow-primary-border`}>
            <QRCodeCanvas
              value={qrCodeLink}
              level="H"
              size={868}
              imageSettings={{
                src: quiz.publicLeaderboard.quizQRCodeLogo || '',
                width: isRectLogoFormat ? 300 : 200,
                height: isRectLogoFormat ? 150 : 200,
                excavate: true
              }}
            />
          </div>
        </div>
        <h2
          className={`shrink-0 w-full truncate italic uppercase font-extrabold text-center ${classes.qrTitle}`}
          style={{
            background: `linear-gradient(90deg, ${quiz.publicLeaderboard.primaryColor}, ${quiz.publicLeaderboard.secondaryColor})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {quiz?.publicLeaderboard.quizQRCodeTitle}
        </h2>
      </div>
    );
  }

  return (
    <div className="">
      <div className="w-1/2 sm:w-full p-3 sm:p-8 rounded-3xl mb-8 portrait:max-w-[600px] portrait:mx-auto shadow-primary-border">
        <div className={`${classes.qrWrapper} flex flex-col p-2 rounded-xl w-full h-full`}>
          <QRCodeCanvas
            value={qrCodeLink}
            level="H"
            size={868}
            imageSettings={{
              src: quiz.publicLeaderboard.quizQRCodeLogo || '',
              width: isRectLogoFormat ? 300 : 200,
              height: isRectLogoFormat ? 150 : 200,
              excavate: true
            }}
          />
        </div>
      </div>
      <div className="relative">
        <h2
          className={`relative pr-3 italic uppercase font-extrabold text-center z-10 ${classes.qrTitle}`}
          style={{
            background: `linear-gradient(90deg, ${quiz.publicLeaderboard.primaryColor}, ${quiz.publicLeaderboard.secondaryColor})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {quiz?.publicLeaderboard.quizQRCodeTitle}
        </h2>
      </div>
    </div>
  )
}

export default QrCode;